export const tr = {
    campaign_broad_match_goal_all: 'Tüm hedeflere göre dönüşüm optimizasyonu',
    campaign_broad_match_goal_changed: '{oldGoal} {newGoal} dönüşüm optimizasyonu',
    campaign_broad_match_goal_id: '"{goalName}" hedefine göre dönüşüm optimizasyonu',
    campaign_broad_match_limit: 'Maksimum harcama: toplam kampanya harcamasında %{limit}',
    campaign_broad_match_limit_changed: 'Maksimum harcama, toplam kampanya harcamasının {newLimit}{oldLimit}',
    'on-all-goals': 'tüm hedeflere göre',
    'on-goal': '"{goalName}" hedefine göre'
};
